import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { waLink } from "../lib/data";

const NAV_LINKS = [
  { href: "#servicios", label: "Servicios", id: "nav-link-servicios" },
  { href: "#tipos", label: "Tipos de Película", id: "nav-link-tipos" },
  { href: "#proyectos", label: "Proyectos", id: "nav-link-proyectos" },
  { href: "#proceso", label: "Proceso", id: "nav-link-proceso" },
  { href: "#blog", label: "Blog", id: "nav-link-blog" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0A0B0E]/85 backdrop-blur-2xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a
          href="#inicio"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="relative flex items-center justify-center w-10 h-10 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/5 group-hover:bg-[#D4AF37]/15 transition-colors">
            <span className="font-display text-[#D4AF37] text-lg leading-none italic">P</span>
            <span className="absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full bg-[#D4AF37]" />
          </span>
          <div className="leading-tight">
            <div className="font-display text-white text-lg tracking-tight">
              Polarizados <span className="italic text-[#D4AF37]">Querétaro</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40">
              PPQ · Películas y Polarizados
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-sm text-white/65 hover:text-white transition-colors uppercase tracking-[0.18em]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-whatsapp-cta"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#D4AF37] text-black text-sm font-medium hover:bg-[#E5C04A] transition-all hover:shadow-[0_0_30px_rgba(212,175,55,0.35)]"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-black animate-pulse" />
            Cotizar gratis
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-white"
            aria-label="Menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="lg:hidden bg-[#0A0B0E]/95 backdrop-blur-2xl border-t border-white/5 px-6 py-8"
        >
          <div className="flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.id}`}
                className="text-base text-white/80 hover:text-[#D4AF37] uppercase tracking-[0.18em]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="mt-4 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#D4AF37] text-black font-medium"
            >
              Cotizar por WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
